import variables from '../../variables';
import Waves from 'node-waves';

export default function initWaves(duration = variables.carouselDefaultDuration / 1.5) {
  Waves.attach('.button--waves', ['waves-button']);
  Waves.init({duration});
  return Waves;
}